import { type StorageInterface } from 'core/infra/storage/StorageInterface'

import sentry from 'legacy/utils/sentry'

import { MAGIC_LINK_STORAGE_TOKEN_KEY } from '../domain/magicLinkToken'
import { type UserRepository } from './userRepository'

type MagicLinkUserRepositoryDeps = {
  storage: StorageInterface
}

export class MagicLinkUserRepository implements UserRepository {
  private storage: StorageInterface

  constructor({ storage }: MagicLinkUserRepositoryDeps) {
    this.storage = storage
  }

  getLocalToken(): string | undefined {
    try {
      return this.storage.get<string>(MAGIC_LINK_STORAGE_TOKEN_KEY) ?? undefined
    } catch (error) {
      sentry.log(error)
      return undefined
    }
  }

  setLocalToken(token: string) {
    this.storage.set(MAGIC_LINK_STORAGE_TOKEN_KEY, token)
  }
}
